<!-- 获取授权商可发放通用券模板信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "queryType": 1,
                "pageNum": 1,
                "pageSize": 10
            },
            responseCode: {
                "data": {
                    "couponTemplateInfoList": [
                        {
                            "billUseType": "0",
                            "code": "8S30EDCU15XF",
                            "couponType": 1,
                            "createTime": "2019-04-29 14:18:51",
                            "faceValue": "1",
                            "grantNum": 2,
                            "isCover": 0,
                            "maxCoverNum": 0,
                            "name": "城市运营测试抵扣1元券",
                            "recycledNum": 0,
                            "status": 1,
                            "totalNum": 10,
                            "useRule": "0<=${money}&&${money}<=999",
                            "usedNum": 0,
                            "validFrom": "2019-04-28 00:00:00",
                            "validTime": 10080,
                            "validTo": "2020-04-28 00:00:00",
                            "wxAppid": "wx4965abff0ba79af7"
                        },
                        {
                            "billUseType": "0",
                            "code": "8S303FTHIFXM",
                            "couponType": 1,
                            "createTime": "2019-04-29 11:56:05",
                            "faceValue": "1",
                            "grantNum": 2,
                            "isCover": 0,
                            "maxCoverNum": 0,
                            "name": "城市运营测试抵扣1元券",
                            "recycledNum": 0,
                            "status": 1,
                            "totalNum": 1,
                            "useRule": "0<=${money}&&${money}<=999",
                            "usedNum": 0,
                            "validFrom": "2019-04-28 00:00:00",
                            "validTime": 10080,
                            "validTo": "2020-04-28 00:00:00",
                            "wxAppid": "wx4965abff0ba79af7"
                        }
                    ]
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取获取城市运营券模板信息",
                t_url: this.commonUrls.test+"queryCityOperationCouponTemplateInfo",
                p_url: this.commonUrls.prod+"queryCityOperationCouponTemplateInfo",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'queryType', info2: '是', info3: 'Integer', info4: '搜索范围 0 查询指定的券; 1 查询所有券;' },
                        { info1: 'couponTemplateCode', info2: '否', info3: 'String', info4: '券模版编码, 传入此参数代表要查询指定的券。queryType=0时必填' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponTemplateList', info2: '是', info3: 'JSONArray', info4: '券模板信息列表' }
                    ]
                },{
                    titleName: 'couponTemplateList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'code', info2: '是', info3: 'String', info4: '券模板编码' },
                        { info1: 'name', info2: '是', info3: 'String', info4: '模板名称' },
                        { info1: 'wxAppid', info2: '是', info3: 'String', info4: '所属微信公众号appid' },
                        { info1: 'couponType', info2: '是', info3: 'Integer', info4: '券类型 0:免费券,1:金额扣减券,费减免固定金额结算,2:金额折扣券,车费折扣减免结算,3:金额固定值券,车费按券的固定值结算,4:时间券,时间减免后再按车费结算' },
                        { info1: 'faceValue', info2: '是', info3: 'Decimal', info4: '面值金额，单位元' },
                        { info1: 'status', info2: '是', info3: 'Integer', info4: '券模板状态（0：未启用，1：启用，2:删除）' },
                        { info1: 'useRule', info2: '是', info3: 'String', info4: '使用规则' },
                        { info1: 'extraProperty', info2: '否', info3: 'String', info4: '时间券的相关配置' },
                        { info1: 'isCover', info2: '是', info3: 'Integer', info4: '是否可叠加使用' },
                        { info1: 'maxCoverNum', info2: '是', info3: 'Integer', info4: '最大叠加数' },
                        { info1: 'validFrom', info2: '是', info3: 'String', info4: '券可发放的开始时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'validTo', info2: '是', info3: 'String', info4: '券可发放的结束时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'validTime', info2: '是', info3: 'Integer', info4: '发券后券的有效时间（单位: 分钟）' },
                        { info1: 'billUseType', info2: '是', info3: 'String', info4: '适用业务类型 0: PARKING停车费, 1: MONTH_TICKET月票，多种类型逗号分隔 如0,1' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '券备注' },
                        { info1: 'createTime', info2: '是', info3: 'Long', info4: '创建时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'totalNum', info2: '是', info3: 'Integer', info4: '券总数量' },
                        { info1: 'grantNum', info2: '是', info3: 'Integer', info4: '已发放数量' },
                        { info1: 'usedNum', info2: '是', info3: 'Integer', info4: '已使用数量' },
                        { info1: 'recycledNum', info2: '是', info3: 'Integer', info4: '已回收数量' },
                        { info1: 'parkInfoList', info2: '是', info3: 'JSONArray', info4: '适用停车场列表' },
						{ info1: 'coverUrl', info2: '否', info3: 'String', info4: '封面URL' },
						{ info1: 'logoUrl', info2: '否', info3: 'String', info4: 'LOGO_URL' }
						]
                },
                  {
                    titleName: "parkInfoList",
                    tabledata: [
                      {tableHead: "参数名", tdName: "info1"}, {tableHead: "是否必填", tdName: "info2"}, {tableHead: "类型", tdName: "info3"}, {tableHead: "说明", tdName: "info4"}
                    ],
                    td: [
                      { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                      { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                    ]
                  }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/cityOperationCoupon/queryCityOperationCouponTemplateInfo.vue